import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, ErrorLogViewModel, GithubIssueViewModel, SupportTicketViewModel } from "../../core/api/models";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { Table, TableRowCollapseEvent, TableRowExpandEvent } from "primeng/table";
import { ErrorLogApiService } from "../../core/api/services";
import { DomSanitizer } from "@angular/platform-browser";
import { formatDate, formatNumber } from "@angular/common";




@Component({
  selector: 'app-exception-log-list-component',
  templateUrl: './exception-log-list.component.html',
  styleUrl: './exception-log-list.component.css',
  standalone: false
})
export class ExceptionLogListComponent implements OnInit, AfterViewInit {



  public pageTitle: string = 'Exception Logs';


  selectedItems: any = undefined;
  expandedRows: any = {};

  gitHubIssueVisible: boolean = false;
  loadingGitHubIssue: boolean = false;
  gitHubIssues: GithubIssueViewModel[] | null = null;
  gitHubIssue: GithubIssueViewModel | null = null;
  gitHubComment?: string;
  gitHubTitle?: string;
  gitHubSelectedItems: ErrorLogViewModel[] | null = null;



  ticketVisible: boolean = false;
  loadingTicket: boolean = false;
  tickets: SupportTicketViewModel[] | null = null;
  ticket: SupportTicketViewModel | null = null;
  ticketSelectedItems: ErrorLogViewModel[] | null = null;

  filter: any = {};
  list: any = undefined;
  loadingList: boolean = true;

  @ViewChild('dt1') table?: Table;


  loading: boolean = false;



  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: ErrorLogApiService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder) {
  }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params: ParamMap) => {
      console.info('Loading ' , params);
    });

    this.authService.checkIfAutorized([ArkUserType.Developer, ArkUserType.Admin]);

  }

  ngAfterViewInit(): void {
  }

  loadTable(event: any) {
    if (event || !this.filter) {
      this.filter = Utils.normalizePrimeDatatableEvent(event || this.filter || { filters: {} });
    }

    this.loadingList = true;
    this.apiService.List({ body: this.filter })
      .forEach(
        (result) => {
          this.list = result;
          this.loadingList = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
          });
  }



  clear(table: Table) {
    this.table = table;
    table.clear();
  }


  expandAll() {
    this.expandedRows = this.list?.Result.reduce((acc: any, p: any) => (acc[p.ID] = true) && acc, {});
  }

  collapseAll() {
    this.expandedRows = {};
  }

  onRowExpand(event: TableRowExpandEvent) {
    //this.alertService.info(event.data);
  }

  onRowCollapse(event: TableRowCollapseEvent) {
    // this.alertService.info(event.data);
  }

  selectedAll() {
    this.selectedItems = this.list?.Result;
  }

  selectedNone() {
    this.selectedItems = [];
  }

  onSelectionChange(event: any) {
  }



  deleteSelected() {


    if (!this.selectedItems || this.selectedItems.length == 0) {
      this.alertService.error('Please select an item first');
      return;
    }

    let ids = [] as number[];
    for (let i of (this.selectedItems as ErrorLogViewModel[]))
      if (i.ID)
        ids = ids.concat(i.ID.map(k => k || 0));

    // group ids in set of 100 items
    
    let chunk = 1000;
    for (let i = 0; i < ids.length; i += chunk) {
      let c = Math.min(chunk, ids.length - i);
      let part = ids.slice(i, i + c);
    
      this.loading = true;
      this.apiService.Delete({ body: { id: part } })
        .forEach(
          () => {

            this.loading = false;
            this.selectedItems = [];
            this.alertService.success(` ${c} Items deleted successfully`);
            this.loadTable(null);

          }).catch(
            err => {
              this.loading = false;
              this.alertService.error(Utils.getAjaxError(err));
              i = ids.length;
            });

    }
  }

  delete(item: ErrorLogViewModel | undefined) {


    this.loading = true;

    let ids = item?.ID?.map(i => i|| 0);
    this.apiService.Delete({ body: { id: ids } })
      .forEach(
        () => {

          this.loading = false;
          this.alertService.success('Item deleted successfully');
          this.loadTable(null);

        }).catch(
          err => {
            this.loading = false;
            this.alertService.error(Utils.getAjaxError(err));

          });


  }


  getTimeFromNow(date: Date) {
    if ((new Date().getTime()) - (new Date(date).getTime()) > 1000 * 60 * 60 * 36) {
      return formatDate(date, 'shortDate', 'en-US');
    }
    return Utils.getTimeFromNow(date);
  }
  formatMountainTime(date: Date) {

    return Utils.formatMountainTime(date);
  }


  showLinkGitHub(item: ErrorLogViewModel | undefined) {
    
    if (item?.GitHub_IssueNumber) {
      var url = `https://github.com/UTBS/${item?.GitHub_Repository}/issues/${item?.GitHub_IssueNumber}`;
       var w = window.open(url);
       if (!w)
         location.href = url;
       return;
     }

    this.selectedItems = [item];
    this.showLinkGitHubSelected();

  }

  showLinkGitHubSelected() {

    if (!this.selectedItems || this.selectedItems.length == 0) {
      this.alertService.error('Please select an item first');
      return;
    }
    

    this.gitHubTitle = `Error-${this.selectedItems[0].ID[0]}: ${this.selectedItems[0].Message || ''}`;
    this.gitHubIssueVisible = true;

    this.gitHubSelectedItems = this.selectedItems;

    if (!this.gitHubIssues) {
      this.loadingGitHubIssue = true;
      this.gitHubIssues = [{ title: 'Create new issue', number: 0, repository: '' }];
      this.gitHubIssue = this.gitHubIssues[0];
      this.apiService.GetGitHubIssues()
        .forEach((result) => {
          this.loadingGitHubIssue = false;
          result.splice(0, 0, { title: 'Create new issue', number: 0, repository: '' });

          this.gitHubIssues = result;

          var myTitle = `Error-${this.selectedItems[0]?.ID}:`;
          var r = result.find(x => x.title && x.title.indexOf(myTitle) !== -1)
          if (!r)
            r = result.find(x => x.title && x.title.indexOf(this.selectedItems[0]?.Message || '') !== -1)
          if (!r)
            r = result[0];

          this.gitHubIssue = r;

        }).catch(
          err => {
            this.loadingGitHubIssue = false;
            this.alertService.error(Utils.getAjaxError(err));
          });
    }

  }


  linkGitHub() {
    if (!this.gitHubSelectedItems || !this.gitHubSelectedItems.length || !this.gitHubIssue)
      return;
    console.debug(this.gitHubIssue);

    let ids = this.gitHubSelectedItems.flatMap((item) => item.ID || 0);

    this.loading = true
    this.apiService.LinkGitHubIssue({
      body: {
        exceptionIDs: ids,
        GitHub_IssueNumber: this.gitHubIssue.number,
        GitHub_Repository: this.gitHubIssue.repository || undefined,
        title: this.gitHubTitle || undefined,
        comment: this.gitHubComment || undefined
      }
    })
      .forEach((result) => {
        this.loading = false;
        this.gitHubIssueVisible = false;
        this.loadTable(null);
        this.alertService.success('Item linked successfully');

        if (!this.gitHubIssue?.number && result.number) {
          var url = `https://github.com/UTBS/${result.repository}/issues/${result.number}`;
          var w = window.open(url);
          if (!w)
            location.href = url;

          this.gitHubIssue = result;
          if (this.gitHubIssues && this.gitHubIssue && this.gitHubIssue.number == 0)
            this.gitHubIssues.push({ title: result.title, number: result.number, repository: result.repository });

        }

      }).catch(
        err => {
          this.loading = false;
          this.alertService.error(Utils.getAjaxError(err));
        });
  }

  showLinkTicket(item: ErrorLogViewModel | undefined) {
    if (item?.SupportTicketID) {
      this.router.navigate(['/tickets', item?.SupportTicketID]);
      return;
    }

    this.selectedItems = [item];
    this.showLinkTicketSelected();
  }
  showLinkTicketSelected() {

    if (!this.selectedItems || this.selectedItems.length == 0) {
      this.alertService.error('Please select an item first');
      return;
    }
    this.ticketVisible = true;

    this.ticketSelectedItems = this.selectedItems;

    if (!this.tickets) {
      this.loadingTicket = true;
      this.apiService.GetBugSupportTickets()
        .forEach((result) => {
          this.loadingTicket = false;
          if (result.length == 0) {

            this.alertService.info('No open bug support tickets');
          }

          this.tickets = result;
          this.ticket = result[0];

        }).catch(
          err => {
            this.loadingTicket = false;
            this.alertService.error(Utils.getAjaxError(err));
          });
    }
  }
  linkTicket() {
    if (!this.ticketSelectedItems || !this.ticketSelectedItems.length || !this.ticket)
      return;
    console.debug(this.ticket);


    let ids = this.ticketSelectedItems.flatMap((item) => item.ID || 0);

    this.loading = true
    this.apiService.LinkSupportTicket({
      body: {
        exceptionIDs: ids,
        supportTicketID: this.ticket.ID
      }
    })
      .forEach((result) => {
        this.loading = false;
        this.ticketVisible = false;
        this.loadTable(null);
        this.alertService.success('Item linked successfully');

      }).catch(
        err => {
          this.loading = false;
          this.alertService.error(Utils.getAjaxError(err));
        });
  }
}
